var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarSimple = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.75 1.25a5 5 0 0 1 5 5v7.5a5 5 0 0 1-5 5h-7.5a5 5 0 0 1-5-5v-7.5a5 5 0 0 1 5-5zm3.125 6.25H3.125v6.25c0 1.726 1.4 3.125 3.125 3.125h7.5c1.726 0 3.125-1.4 3.125-3.125z"
})));
SvgCalendarSimple.displayName = "SvgCalendarSimple";
export { SvgCalendarSimple as ReactComponent };
export default SvgCalendarSimple;